import {
  RS_TRANSACTION_CREATE_FETCH, RS_TRANSACTION_CREATE_SUCCESS,
  RS_TRANSACTIONS_FETCH,
  RS_TRANSACTIONS_SUCCESS
} from '../../../actions/dashboard/rsTransactions';
import { IDLE, LOADING, SUCCESS } from '../../../../enums/states';
import { createReducer } from '../../utils/reducer';

const initialState = {
  data: null,
  metadata: {
    state: IDLE,
    error: null
  }
};

const handlers = {
  [RS_TRANSACTIONS_FETCH]: (state) => {
    return {
      ...state,
      metadata: {
        state: LOADING,
      }
    };
  },

  [RS_TRANSACTIONS_SUCCESS]: (state, action) => {
    return {
      ...state,
      data: transformData(action.payload),
      metadata: {
        state: SUCCESS,
      }
    };
  },

  [RS_TRANSACTION_CREATE_FETCH]: (state, action) => {
    return {
      ...state,
      data: updateData(state.data, action.id, (item) => {
        return {
          ...item,
          metadata: {
            ...item.metadata,
            state: LOADING
          }
        };
      }),
    };
  },

  [RS_TRANSACTION_CREATE_SUCCESS]: (state, action) => {
    return {
      ...state,
      data: updateData(state.data, action.id, (item) => {
        return {
          ...item,
          metadata: {
            ...item.metadata,
            state: SUCCESS,
            transactionId: action.transactionID
          }
        };
      }),
    };
  },
};


const updateData = (items, id, callback) => items.map((item) => {
  if (item.data.ID !== id) {
    return item;
  } else {
    return callback(item);
  }
});

const transformData = (data) => data.map((item) => ({
  ...initialState,
  data: item,
}));

export default createReducer(initialState, handlers);
